import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppFooter } from './app.footer';
import { AppTopbar } from './app.topbar';

@Component({
    selector: 'app-layout',
    standalone: true,
    imports: [AppTopbar, AppFooter, RouterModule],
    templateUrl: './app.layout.html'
})
export class AppLayout {}
